import { useMemo } from 'react';
import { useRuntimeConfig } from '../runtimeConfig';
import { usePublicFn } from './usePublic';

const useCompanyBranding = () => {
    const { branding } = useRuntimeConfig();
    const getPublic = usePublicFn();

    return useMemo(
        () => ({
            logoUrl: branding?.logoUrl ?? getPublic('assets/images/porscheLogo.png'),
            faviconUrl: branding?.faviconUrl ?? getPublic('assets/images/porscheFavicon.png'),
        }),
        [branding?.faviconUrl, branding?.logoUrl, getPublic]
    );
};

export default useCompanyBranding;
